import React, { useState } from "react";
import { Drawer, List, Stack } from "@mui/material";
import { Box } from "@mui/material";
import { corGeral } from "../../../Styles/cores";
import LogoTelegen from "../../../Assets/Img/Telegen/logo-telegen.png";
import ListItemButton from "./ListItemButton";
import CustomCollapse from "./CustomCollapse";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../Constants/routes";

interface ISideMenuProps {
  isOpen: boolean;
  handleDrawerToggle: () => void;
}

const SideMenu: React.FC<ISideMenuProps> = ({ isOpen, handleDrawerToggle }) => {
  const navigate = useNavigate();
  const [openSection, setOpenSection] = useState<string | null>(null);

  const handleSectionToggle = (sectionId: string) => {
    setOpenSection((prevSection) =>
      prevSection === sectionId ? null : sectionId
    );
  };

  return (
    <Drawer
      open={isOpen}
      onClose={handleDrawerToggle}
      sx={{
        zIndex: 2200,
        '& .MuiDrawer-paper': {
          backgroundColor: corGeral.navyBlue,
          color: "white",
          minWidth: "20vw",
        },
      }}
    >
        <Box display="flex" justifyContent="center" m="20px 0" minWidth={"280px"}>
          <img
            style={{ margin: "40px 0" }}
            src={LogoTelegen}
            alt="Logo Telegen"
            width="200px"
          />
        </Box>
        <List sx={{ margin: "0 12px 20px 12px" }}>
          <Stack gap={1}>
            {/* <ListItemButton
              label="Home"
              onClick={() => navigate(routes.BASE)}
            /> */}
            <ListItemButton
              label="Avaliações"
              onClick={() => navigate(routes.OS_AVALIACAO_LIST)}
            />
            <ListItemButton
              label="Notificações"
              onClick={() => navigate(routes.NOTIFICACAO_LIST)}
            />
            <CustomCollapse
              label="Ordens de serviço"
              onClick={() => handleSectionToggle("ordens-de-servico")}
              isOpen={openSection === "ordens-de-servico"}
            >
              <ListItemButton
                label="Criar OS"
                onClick={() => navigate(routes.OS_CREATE)}
              />
              <ListItemButton
                label="Listar OS"
                onClick={() => navigate(routes.OS_LIST)}
              />
              <ListItemButton
                label="Calendário"
                onClick={() => navigate(routes.OS_CALENDAR)}
              />
            </CustomCollapse>
            <ListItemButton
              label="Clientes"
              onClick={() => navigate(routes.CLIENTE_LIST)}
            />
            <ListItemButton
              label="Equipamentos"
              onClick={() => navigate(routes.EQUIPAMENTO_LIST)}
            />
            <ListItemButton
              label="Técnicos"
              onClick={() => navigate(routes.TECNICO_LIST)}
            />
            {/* <ListItemButton label="Sair" onClick={() => navigate("/")} /> */}
          </Stack>
        </List>
        <Box onClick={() => navigate("/")} style={{ cursor: "pointer", textAlign: "center", margin: "20px 0", width: "fit-content", alignSelf: "center" }}>Sair</Box>
    </Drawer>
  );
};

export default SideMenu;
